export default "__VITE_ASSET__B54DDK1f__"